import { useCallback, useEffect, useState } from 'react';
const config = require('@gral/config.js');
import { useAppDispatch, useAppSelector } from '@redux/store';
import { fetchData } from '@redux/slices/functionals/request/requestActions';
import { Grid } from '@ts/storybook';

const Logo = () => {
  const dispatch = useAppDispatch();
  const logoSettings = useAppSelector(state => state.global.settings?.logo);
  const [logoLinkCaption, setLogoLinkCaption] = useState<string>('');
  const [logoLink, setLogoLink] = useState<string>('');
  const [logoSrc, setLogoSrc] = useState<string>('');

  const fetchLogo = useCallback(async () => {
    if (logoSettings?.logoId) {
      return dispatch(fetchData({ key: 'getLogo', url: `/api/document/${logoSettings?.logoId}` })).then(res => {
        return res?.payload?.data;
      });
    }
  }, [logoSettings?.logoId, dispatch]);

  useEffect(() => {
    (async () => {
      const logoDbImage = await fetchLogo();

      if (logoDbImage?.locator) setLogoSrc(logoDbImage?.locator);
      else setLogoSrc(require(`../../public/assets/logo/${config.getLogo()}`));

      if (logoSettings?.logoCaption) setLogoLinkCaption(logoSettings.logoCaption);
      else setLogoLinkCaption(config.getLogoLinkCaption());

      if (logoSettings?.logoUrl) setLogoLink(logoSettings.logoUrl);
      else setLogoLink(config.getLogoLink());
    })();
  }, [logoSettings]);

  return (
    <Grid id="container-logo" container alignItems="center">
      <Grid id="logo" size="auto" className="h-12 w-full">
        <a href={logoLink} title={logoLinkCaption}>
          <img className="h-auto max-h-full max-w-full" src={logoSrc || undefined} />
        </a>
      </Grid>
    </Grid>
  );
};

export default Logo;
